"use strict";

var _StaticMFEShadowedCom;
import { TENANT_NAME } from '@autoguru/global-configs';
import { StaticMFEShadowedComponent } from '@autoguru/static-mfe/static-mfe-shadowed-component';
import { useSelectedGlobalSupplier } from '../GlobalSupplierProvider';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const SupplierRequiredBoundary = ({
  children,
  noSelect
}) => {
  const {
    id
  } = useSelectedGlobalSupplier();
  return TENANT_NAME !== 'nz' || id ? /*#__PURE__*/_jsx(_Fragment, {
    children: children
  }) : noSelect ? null : _StaticMFEShadowedCom || (_StaticMFEShadowedCom = /*#__PURE__*/_jsx(StaticMFEShadowedComponent, {
    width: "full",
    mfeAppName: "sp-supplier-select-home"
  }));
};